module.exports = "pegasus_template/assets/preview-5.png";